'use client';

import createPath from '@local/router/createPath';
import { RouteName } from '@local/router/routes';
import { createPathToTutorial } from '@local/tutorial/services/routing';
import Link from 'next/link';
import { useState } from 'react';

export default function Navigation({ onReset }: { onReset: () => void }) {
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    function handleShowMenu() {
        setIsMenuVisible(true);
    }

    function handleHideMenu() {
        setIsMenuVisible(false);
    }

    function handleResetGame() {
        onReset();
        setIsMenuVisible(false);
    }

    return (
        <>
            <button className="button game-navigation-button" onClick={handleShowMenu}>
                <span className="icon-text icon-with-text">
                    <span className="icon">
                        <i className="fas fa-bars"></i>
                    </span>
                    <span>Menu</span>
                </span>
                <span className="icon-only">
                    <span className="icon">
                        <i className="fas fa-bars"></i>
                    </span>
                </span>
            </button>
            <div className={`modal ${isMenuVisible ? 'is-active' : ''}`}>
                <div className="modal-background" onClick={handleHideMenu}></div>
                <div className="modal-content">
                    <div className="box is-flex is-flex-direction-column is-justify-content-space-between">
                        <Link className="button is-info" href={createPath(RouteName.Homepage)}>
                            Home
                        </Link>
                        <Link
                            className="button is-info mt-2"
                            href={createPath(RouteName.Scenarios)}
                        >
                            Scenarios
                        </Link>
                        <Link
                            className="button is-info mt-2"
                            href={createPath(RouteName.LearningScenarios)}
                        >
                            Learning Scenarios
                        </Link>
                        <Link className="button is-info mt-2" href={createPathToTutorial(1)}>
                            Tutorial
                        </Link>
                        <button className="button is-warning mt-2" onClick={handleResetGame}>
                            Reset Current Game
                        </button>
                    </div>
                </div>
                <button
                    className="modal-close is-large"
                    aria-label="close"
                    onClick={handleHideMenu}
                ></button>
            </div>
        </>
    );
}
